import React, { useState, useEffect, useContext, useReducer } from "react";
import {
    Button,
    Tabs,
    TabList,
    TabPanels,
    TabPanel,
    Tab,
    useMediaQuery,
    Flex,
    Center,
    Box,
    Text,
} from "@chakra-ui/react";
import { getAccount, getAuthUrl, updateUser } from "../../utils/sessionHelper";
import { useFirebaseUser } from "../../utils/useFirebaseUser";
import { BiComment, BiSearch } from "react-icons/bi";
import { RxLockClosed } from "react-icons/rx";
import { RetrieveComments } from "./reply-to-comments/retrieve-present-comments";
import { CommentsByURL } from "./reply-to-comments/search-comments-by-url";
import { useSession } from "next-auth/react";
import { color, textStyle, variant } from "theme/names";
import { GetExtension } from "components/get-extension";

export const ReplyToCommentsPanel = ({ }) => {

    const { data: session, status } = useSession() ?? {}
    const loading = status === "loading"
    const [tabIndex, setTabIndex] = useState<number>(0);
    const [planType, setPlanType] = useState<string | undefined | null>(getAccount(session)?.subscription?.plan);
    const [nbCommentFetchLimits, setNBCommentFetchLimit] = useState<number>(25);
    const isAuthenticated = useFirebaseUser();
    let isValidToken = getAccount(session)?.thWriteAccessToken;
    const [isTooSmall] = useMediaQuery("(max-width: 800px)");

    useEffect(
        () => {
            setPlanType(getAccount(session)?.subscription?.plan);
        }, [session]
    );

    useEffect(() => {
        const commentFetchLimists = (planType == "enterprise") ? 500 : 25;
        setNBCommentFetchLimit(commentFetchLimists);
        // console.log(commentFetchLimists, planType, 'comments - panel - limits');
    }, [planType]);

    if (planType == "starter") return null;
    // console.log(planType, 'reply to comments')
    return (
        <>
            <Tabs
                onChange={(index) => {
                    setTabIndex(index);
                }}
                index={tabIndex}
                defaultIndex={0}
                variant={"primary"}
                isLazy
                mt={3}
                w={"full"}
                alignContent="center"
                justifyContent="center"
                gap={5}
            >
                <TabList gap={2} alignItems={"center"} justifyContent={"center"}>
                    <Tab
                        as={Button}
                        variant={(tabIndex === 0) ? "primary" : "outline"}
                        leftIcon={<BiComment />}
                        disabled={(!isAuthenticated || !isValidToken)}
                        fontSize={(isTooSmall) ? "12px" : "sm"}
                    >
                        Retrieve my comments
                    </Tab>
                    <Tab
                        as={Button}
                        variant={(tabIndex === 1) ? "primary" : "outline"}
                        leftIcon={(getAccount(session)?.subscription?.plan != "enterprise") ? <RxLockClosed /> : <BiSearch />}
                        disabled={(!isAuthenticated || !isValidToken)}
                        fontSize={(isTooSmall) ? "12px" : "sm"}
                    >
                        Search by post URL
                    </Tab>
                </TabList>
                <RTCInnerPanels
                    planType={planType}
                    postLimit={5}
                    commentFetchLimists={nbCommentFetchLimits}
                    isAuthenticated={isAuthenticated}
                    isValidToken={isValidToken}
                    idUser={getAccount(session)?.id}
                />
            </Tabs>
        </>

    );
}

const RTCInnerPanels = ({
    planType,
    postLimit,
    commentFetchLimists,
    isAuthenticated,
    isValidToken,
    idUser
}) => {

    const { data: session, status } = useSession() ?? {}
    const loading = status === "loading"
    const [autoLike, setAutoLike] = useState<boolean>(false);

    useEffect(() => {
        if (getAccount(session)?.autoLikeOnReply)
            setAutoLike(getAccount(session)?.autoLikeOnReply);
    }, [session]);

    const onAutoLike = async (auLike: boolean) => {
        await updateUser(session, { autoLikeOnReply: !auLike });
        setAutoLike(!auLike);
    };

    useEffect(
        () => {
            if (session && getAccount(session)?.autoLikeOnReply === undefined) {
                updateUser(session, { autoLikeOnReply: true });
                setAutoLike(true);
            } else {
                setAutoLike(getAccount(session)?.autoLikeOnReply);
            }
        }, [session]
    );

    if (!loading && session && !getAccount(session)?.idLinkedin) {
        return (<GetExtension />);
    }

    return (
        <TabPanels mt={5}>
            <TabPanel px="0">
                <RetrieveComments
                    planType={planType}
                    postLimits={postLimit}
                    commentFetchLimists={commentFetchLimists}
                    username={getAccount(session)?.username}
                    idLinkedin={getAccount(session)?.idLinkedin}
                    dashEntityUrn={getAccount(session)?.dashEntityUrn}
                    isAuthenticated={isAuthenticated}
                    isValidToken={isValidToken}
                    idUser={idUser}
                    isInfluentLeader={getAccount(session)?.isInfluentLeaders}
                    autoLike={autoLike}
                    onAutoLike={onAutoLike}
                />
            </TabPanel>
            <TabPanel px="0">
                <CommentsByURL
                    planType={planType}
                    commentFetchLimists={commentFetchLimists}
                    isAuthenticated={isAuthenticated}
                    isValidToken={isValidToken}
                    idUser={idUser}
                    isInfluentLeader={getAccount(session)?.isInfluentLeaders}
                    autoLike={autoLike}
                    onAutoLike={onAutoLike}
                />
            </TabPanel>
        </TabPanels>
    )
}